export enum MYPLANS_KEYS {
  ADD_AND_SAVE_BUTTON = 'addAndSaveProduct',
  MANAGE_KEY = 'MANAGE',
  REVIEW_KEY = 'REVIEW',
  CHECKOUT_KEY = 'CHECKOUT',
  MONTHLY_KEY = 'MONTHLY',
  UNLIMITED_DATA_KEY = 'Unlimited Data',
  RECURRING_UNLIMITED_30_KEY = 'Recurring GM Unlimited 30 Days',
  PREPAID_KEY = 'PREPAID',
  REVIEW_ID_SESSION_KEY = 'ReviewId',
  SUPER_CRUISE_KEY = 'Super Cruise',
  CONNECT_PLUS_FEATURE_KEY = 'Connect Plus',
  CONNECT_PLUS_PRODUCT_KEY = 'OnStar Connect Plus'
}
